import fetch from '../config/api'

/**
 * 学术列表(已结)
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {type} 1 表示学术期刊 2表示学术讲堂
 * param {num} 分页时表示从第几条开始取
 * param {take} 分页时该值表示每页多少条数据
 */
const StudyList = (language = '1', type = '1', num = '0', take = '10') => fetch('/study/list', {
    p: 'wx',
    language,
    type,
    skip: num * take, //从第几个开始
    take //取几条数据
});

/**
 * 学术详情
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {study_id} 学术ID
 */
const StudyDetail = (language = '1', study_id) => fetch('/study/detail', {
    p: 'wx',
    language,
    study_id
});

/**
 * 下载次数
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {study_id} 学术ID
 */
const StudyDownloadCount = (language = '1', study_id) => fetch('/study/incr_download_count', {
    p: 'wx',
    language,
    study_id
}, 'POST');

export default {
    StudyList,
    StudyDetail,
    StudyDownloadCount
}